import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { TBitValue } from "../../data/AppType";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { paginationParams, toQueryString } from "../../utils/QueryString";

export interface IFirmPurchasedSubscriptionFilter {
  firmId: string | null;
  showHistoricalRecords: TBitValue;
  source: string | null;
}

interface ISubscriptionAssignmentPayload {
  firm_id: string;
  subscription_package_id: string;
  confirm_replace: boolean;
}

export const GET_ALL_FIRM_PURCHASED_SUBSCRIPTION = (
  pagination: IPagination,
  search: string,
  filter: IFirmPurchasedSubscriptionFilter
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_firm_purchased_subscription.url +
      toQueryString({
        ...paginationParams(pagination),
        search,
        firm_id: filter.firmId,
        showHistoricalRecords: filter.showHistoricalRecords,
        source: filter.source,
      }),
    API_ENDPOINTS.get_all_firm_purchased_subscription.method
  );

export const GET_FIRM_SUBSCRIPTION_DETAIL = (firmId: string) =>
  serviceMaker(
    API_ENDPOINTS.get_firm_subscription_detail.url + `/${firmId}`,
    API_ENDPOINTS.get_firm_subscription_detail.method
  );

export const GET_ASSIGNABLE_SUBSCRIPTION_PACKAGE = () =>
  serviceMaker(
    API_ENDPOINTS.get_assignable_subscription_package.url,
    API_ENDPOINTS.get_assignable_subscription_package.method
  );

export const GET_SUBSCRIPTION_ASSIGNMENT_PREVIEW = (
  firmId: string,
  subscriptionPackageId: string
) =>
  serviceMaker(
    API_ENDPOINTS.get_subscription_assignment_preview.url +
      toQueryString({
        firm_id: firmId,
        subscription_package_id: subscriptionPackageId,
      }),
    API_ENDPOINTS.get_subscription_assignment_preview.method
  );

export const ASSIGN_SUBSCRIPTION = (payload: ISubscriptionAssignmentPayload) =>
  serviceMaker(
    API_ENDPOINTS.assign_subscription.url,
    API_ENDPOINTS.assign_subscription.method,
    payload
  );

export const CANCEL_SUBSCRIPTION = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.cancel_subscription.url + `/${id}`,
    API_ENDPOINTS.cancel_subscription.method
  );
